module.exports = __webpack_public_path__ + "static/media/video-01-ru.7b3f591d.webm";